import api from './../api';

export default {
    getCompany: async (withResponse = false, defaultResponse = null) => {
        let response = await api
            .get('/company')
            .then((res) => res)
            .catch((err) => err.response);

        return withResponse
            ? response
            : response.status === 200
            ? response.data
            : defaultResponse;
    },
};
